import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem('horizon-theme') === 'dark'; }
    catch { return false; }
  });
  useEffect(() => {
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    try { localStorage.setItem('horizon-theme', dark ? 'dark' : 'light'); }
    catch { /* Le thème fonctionne aussi sans stockage disponible. */ }
  }, [dark]);
  return (
    <button
      type="button"
      className="horizon-theme-toggle"
      aria-label="Mode sombre"
      aria-pressed={dark}
      title={dark ? 'Activer le mode clair' : 'Activer le mode sombre'}
      onClick={() => setDark(value => !value)}
    >
      {dark ? <Sun size={18} aria-hidden="true" /> : <Moon size={18} aria-hidden="true" />}
      <span>{dark ? 'Mode clair' : 'Mode sombre'}</span>
    </button>
  );
}
